import { Injectable, OnDestroy } from '@angular/core';
import { Subject, takeWhile } from 'rxjs';
import { AlertBtnText, AlertTypes } from 'src/app/constants';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Injectable({
  providedIn: 'root'
})
export class AlertService implements OnDestroy {

  alertSubject = new Subject();

  destroySubscription = false;

  constructor() {
    this.alertSubject.pipe(takeWhile(() => !this.destroySubscription)).subscribe({
      next: (response: any) => {
        if (response) {
          // if(response.type && response.type === 'error') {
          //   this.error(response.type, response.text);
          // } else if(response.type && response.type === 'success') {
          //   this.success(response.type, response.text);
          // } else if(response.type && response.type === 'info') {
          //   this.info(response.type, response.text);
          // } else if(response.type && response.type === 'errorHtml') {
          //   this.errorHtml(response.html);
          // } else if(response.alertType && response.alertType === 'autoClose') {
          //   this.autoClose(response);
          // }

          if (response.alertType && response.alertType === 'openSwal') {
            this.openSwal(response);
          } else if (response.alertType && response.alertType === 'openSwalHtml') {
            this.openSwalHtml(response);
          } else if (response.alertType && response.alertType === 'autoClose') {
            this.autoClose(response);
          }
        }
      }
    });
  }

  openSwal(response: any) {
    Swal.fire({
      title: response.title ? response.title : '',
      text: response.text ? response.text : '',
      icon: response.icon ? response.icon : AlertTypes.info,
      buttonsStyling: false,
      target: '.storeMain', // .storeMain is default for store side buttons. For manage side this wont find target '.storeMain' and automatically target will set as 'body' for manage side. This way manage side buttons will get applied default theme color and store side buttons will get applied brandBgColor written in shared.service. 

      customClass: {
        confirmButton: 'btn btn-custom-pri',
        icon: this.getIconClass(response.icon)
      },
      didOpen: () => {
        this.applyIdToConfirmBtn();
      }
    })
  }

  openSwalHtml(response: any) {
    Swal.fire({
      title: response.title ? response.title : '',
      icon: response.icon ? response.icon : AlertTypes.info,
      html: response.html ? response.html : '',
      buttonsStyling: false,
      target: '.storeMain', // .storeMain is default for store side buttons. For manage side this wont find target '.storeMain' and automatically target will set as 'body' for manage side. This way manage side buttons will get applied default theme color and store side buttons will get applied brandBgColor written in shared.service.
      customClass: {
        confirmButton: 'btn btn-custom-pri',
        icon: this.getIconClass(response.icon)
      },
      didOpen: () => {
        this.applyIdToConfirmBtn();
      }
    })
  }

  autoClose(response: any) {
    Swal.fire({
      title: response.title ? response.title : '',
      text: response.text ? response.text : '',
      icon: response.icon ? response.icon : AlertTypes.info,
      timer: response.timer ? response.timer : 2000,
      buttonsStyling: false,
      target: '.storeMain', // .storeMain is default for store side buttons. For manage side this wont find target '.storeMain' and automatically target will set as 'body' for manage side. This way manage side buttons will get applied default theme color and store side buttons will get applied brandBgColor written in shared.service.
      customClass: {
        confirmButton: 'btn btn-custom-pri',
        icon: this.getIconClass(response.icon)
      },
      didOpen: () => {
        this.applyIdToConfirmBtn();
      }
    })
  }

  alertConfirmCommon(title?: string, text?: string, icon?: any, confirmButtonText?: string, cancelButtonText?: string, showCancelButton?: boolean) {
    return Swal.fire({
      title: title ? title : "",
      text: text ? text : '',
      icon: icon ? icon : AlertTypes.info,
      showCancelButton: showCancelButton ? showCancelButton : false,
      confirmButtonText: confirmButtonText ? confirmButtonText : AlertBtnText.yes,
      cancelButtonText: cancelButtonText ? cancelButtonText : AlertBtnText.cancel,
      target: '.storeMain', // .storeMain is default for store side buttons. For manage side this wont find target '.storeMain' and automatically target will set as 'body' for manage side. This way manage side buttons will get applied default theme color and store side buttons will get applied brandBgColor written in shared.service. 
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-custom-pri right-space-15',
        cancelButton: 'btn btn-custom-danger',
        icon: this.getIconClass(icon)
      },
      didOpen: () => {
        this.applyIdToConfirmBtn();

        const cancelButton = document.querySelector('.swal2-cancel');
        if (cancelButton) cancelButton.id = 'btnCancel';
      }
    })
  }

  getIconClass(icon: string) {
    if (icon && icon === AlertTypes.success) {
      return 'text-custom-success'
    } else if (icon && icon === AlertTypes.error) {
      return 'text-custom-danger'
    } else if (icon && icon === AlertTypes.warning) {
      return 'text-custom-warning'
    } else {
      return 'text-custom-info'
    }
  }

  applyIdToConfirmBtn() {
    const confirmButton = document.querySelector('.swal2-confirm');
    if (confirmButton) confirmButton.id = 'btnConfirm';
  }

  ngOnDestroy(): void {
    this.destroySubscription = true;
  }
}
